module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Ad-Vol_1.0c57f996.jpg";